<ul *ngIf="showSearch" class="navbar-nav ms-auto">
  <li class="nav-item">
    <div class="input-group">
      <div class="input-group-prepend">
        <select class='form-select' [(ngModel)]="searchType" id="searchSelect">
          <ng-container *ngIf="!isUeTrafikledare()">
            <option value="OrderId" i18n="@@search.order-id">Beställning</option>
            <option value="DriveOrderId" i18n="@@search.driveorder-id">Körorder</option>
            <option value="TripId" i18n="@@search.trip-id">Tur</option>
            <option value="UnboundOrderId" i18n="@@search.unbound-order-id">Friorder</option>
          </ng-container>
          <ng-container *ngIf="isUeTrafikledare()">
            <option value="OrderId" i18n="@@search.order-id">Beställning</option>
            <option value="DriveOrderId" i18n="@@search.driveorder-id">Körorder</option>
            <option value="TripId" i18n="@@search.trip-id">Turnummer</option>
          </ng-container>
        </select>
      </div>
      <div class="search-container">
        <input [(ngModel)]="searchId" type="text" class="form-control" placeholder="Nummer" (keydown.enter)="search()" maxlength="50" i18-placeholder="@@search.search-placeholder">
        <svg (click)="search()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"/></svg>
      </div>
    </div>
  </li>
</ul>
